import { useCallback } from 'react';
import { translations } from '../translations';
import { useLanguage } from '../contexts/LanguageContext';

export const useTranslation = () => {
  const { currentLang, setLanguage } = useLanguage();

  const t = useCallback((key: string) => {
    const keys = key.split('.');
    let value: any = translations[currentLang];
    
    for (const k of keys) {
      value = value?.[k];
      if (value === undefined) return key;
    }
    
    return value;
  }, [currentLang]);

  return {
    t,
    currentLang,
    setLanguage
  };
}; 